import { render } from "./onboarding_index.html?vue&type=template&id=5e0cbe20&scoped=true&external"
import script from "./onboarding_index.js?vue&type=script&lang=js&external"
export * from "./onboarding_index.js?vue&type=script&lang=js&external"

import "./OnboardingIndex.vue?vue&type=style&index=0&id=5e0cbe20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0cbe20"]])

export default __exports__